import { render, staticRenderFns } from "./CoopList.vue?vue&type=template&id=acb0b046&scoped=true"
import script from "./CoopList.vue?vue&type=script&lang=js"
export * from "./CoopList.vue?vue&type=script&lang=js"
import style0 from "./CoopList.vue?vue&type=style&index=0&id=acb0b046&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb0b046",
  null
  
)

export default component.exports